import { AccessProfileEnum } from '@/assets/global/enums/AccessProfileEnum'
import { useUserStore } from '@/stores/userStore'
import type { Ref } from 'vue'
import { processApiResponse, Response } from '@/utils/helpers/toggleSnackBar'
import { useToast } from '@/stores/toastStore'
import { router } from '@/plugins/1.router'

const paramTitle = ref<object>({})

export const setTitle = (newTitle: object) => {
  paramTitle.value = newTitle
}

export const getTitle = (): object => {
  return paramTitle.value
}

export const copyEmail = (email: { email: string; icon: string }) => {
  navigator.clipboard
    .writeText(email.email)
    .then(() => {
      email.icon = 'tabler-copy-check'

      setTimeout(() => {
        email.icon = 'tabler-copy'
      }, 2000)
    })
    .catch((err) => {
      console.error('Erro ao copiar o texto: ', err)
    })
}

export const checkImage = async (url: string) => {
  if (!url) return false

  return new Promise<boolean>((resolve) => {
    const img = new Image()
    img.onload = () => resolve(true)
    img.onerror = () => resolve(false)
    img.src = url
  })
}

export const isCoordinator = (subject: string | undefined) => {
  const userStore = useUserStore()
  return (
    subject === AccessProfileEnum.FUNCTIONALITY.UPDATES &&
    userStore.isCoordinator
  )
}

export const isSpecialist = (subject: string | undefined) => {
  const userStore = useUserStore()
  return (
    subject === AccessProfileEnum.FUNCTIONALITY.UPDATES &&
    userStore.isSpecialist
  )
}

export const isAdminRegional = (subject: string | undefined) => {
  const userStore = useUserStore()
  return (
    subject === AccessProfileEnum.FUNCTIONALITY.UPDATES &&
    userStore.isAdminRegional
  )
}

export const isRegionalCommitteeParticipant = (
  subject: string | undefined,
) => {
  const userStore = useUserStore()
  return (
    subject === AccessProfileEnum.FUNCTIONALITY.PORTFOLIO_UPDATES &&
    (userStore.isRegionalCoordinator || userStore.isRegionalSpecialist)
  )
}

export const showApiToast = (
  dataResponse: Ref<Response | null>,
  dataResult: Ref<Response | null>,
  errorResult: Ref<Response | null>,
) => {
  const useToastStore = useToast()
  const { showSnackbar, responseCode, responseMessage } =
    storeToRefs(useToastStore)

  processApiResponse(
    responseCode,
    responseMessage,
    showSnackbar,
    dataResponse,
    dataResult as Ref<Response | null>,
    errorResult,
  )

  return responseCode.value
}

export const closeApiToast = () => {
  const useToastStore = useToast()
  const { showSnackbar } = storeToRefs(useToastStore)

  showSnackbar.value = false
}

export const redirectInvalidRequest = async (code: number) => {
  // Apenas redireciona para erros 5xx (server error)
  // 401/403 são tratados pelo mecanismo de refresh automático do useApiModified
  if (code >= 500) await router.push('/error')
}

export const buildHeaders = (
  regional: string,
  fingerprint: string,
): Record<string, string> => {
  return {
    'Content-Type': 'application/json',
    'X-Department': regional,
    'X-Device-Fingerprint': fingerprint,
  }
}
